import { useDispatch } from 'react-redux';
import { analyzeProductNotFoundPageView } from '@client/analytics/redux';
import { bindActionCreators } from '@reduxjs/toolkit';

export const useProductNotFoundPageViewAnalytics = (): typeof analyzeProductNotFoundPageView => {
  const dispatch = useDispatch();

  return bindActionCreators(analyzeProductNotFoundPageView, dispatch);
};
